@if(!isEmbedded()) {
<app-nav-rail-container>
  <app-nav-rail class="mat-elevation-z3 d-none d-md-block">
    <a
      routerLink="/"
      class="d-none d-md-block text-decoration-none text-center text-light text-wrap p-2 logo"
    >
      <img
        ngSrc="/assets/logos/pkspot/pkspot_logo_stacked_dark.png"
        alt="PK Spot"
        class="mw-100"
        width="74"
        height="48.02"
      />
    </a>
    @for (button of navbarConfig; track button) { @if(button.spacerBefore) {
    <div class="spacer"></div>
    } @if(button.link) {
    <a [routerLink]="button.link" tabindex="-1">
      <app-mat3-nav-button
        [icon]="button.icon"
        [label]="button.name"
      ></app-mat3-nav-button>
    </a>
    } @else {
    <app-mat3-nav-button
      [matMenuTriggerFor]="button.menu == 'lang' ? langMenu : userMenu"
      [icon]="button.icon"
      [image]="button.image ?? ''"
      [label]="button.name"
    ></app-mat3-nav-button>
    } }

    <!-- terms  -->
    <span
      class="mat-body-small d-flex align-items-center flex-row mb-0 pb-1"
      style="justify-content: space-evenly; width: 100%; font-size: 10px"
    >
      <a routerLink="/terms-of-service">Terms</a>
      <a routerLink="/privacy-policy">Policy</a>
    </span>
  </app-nav-rail>
  <app-nav-rail-content class="flex-col">
    <!-- This is where the pages content gets displayed -->
    <div class="main-content flex-grow-1">
      <router-outlet></router-outlet>
    </div>

    @if(!alainMode) {
    <!-- Bottom navigation bar -->
    <mat-toolbar class="d-md-none mat-elevation-z1">
      @for (button of navbarConfig; track button) { @if(button.link) {
      <a [routerLink]="button.link" tabindex="-1">
        <app-mat3-nav-button
          [icon]="button.icon"
          [label]="button.name"
        ></app-mat3-nav-button>
      </a>
      } @else if(button.function) {
      <app-mat3-nav-button
        (click)="button.function()"
        [icon]="button.icon"
        [label]="button.name"
      ></app-mat3-nav-button>
      } @else {
      <app-mat3-nav-button
        [matMenuTriggerFor]="button.menu == 'lang' ? langMenu : userMenu"
        [icon]="button.icon"
        [image]="button.image ?? ''"
        [label]="button.name"
      ></app-mat3-nav-button>
      } }
    </mat-toolbar>
    } @else {
    <!-- Menu button -->
    <button
      mat-fab
      #mainMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="mainMenu"
      (click)="mainMenuTrigger.openMenu()"
      id="alainMenuButton"
      color="primary"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #mainMenu="matMenu">
      @for(button of navbarConfig; track button) { @if(button.link) {
      <a [routerLink]="button.link">
        <button mat-menu-item>
          <mat-icon>{{ button.icon }}</mat-icon>
          <span>{{ button.name }}</span>
        </button>
      </a>
      }@else if(button.function) {
      <button mat-menu-item (click)="button.function()">
        <mat-icon>{{ button.icon }}</mat-icon>
        <span>{{ button.name }}</span>
      </button>
      } @else {
      <button
        mat-menu-item
        [matMenuTriggerFor]="button.menu == 'lang' ? langMenu : userMenu"
      >
        @if(button.image) {
        <img
          [ngSrc]="button.image"
          width="24"
          height="24"
          class="rounded-circle"
          style="margin-right: 12px"
        />
        } @else {<mat-icon>{{ button.icon }}</mat-icon
        >}
        <span>{{ button.name }}</span>
      </button>
      } }
    </mat-menu>
    }

    <!-- Terms and Privacy -->

    <!-- <div
      class="d-flex d-md-none w-100 pt-1 px-3 mat-body-small justify-content-end align-items-center flex-row mb-0 pb-1 gap-3"
      style="background-color: #1f1f23; font-size: 10px"
    >
      <a routerLink="/terms-of-service">Terms of Service</a>
      <a routerLink="/privacy-policy">Policy Policy</a>
      <span>©2025 Lukas Bühler</span>
    </div> -->
  </app-nav-rail-content>
</app-nav-rail-container>

} @else {
<div class="d-flex flex-column h-100">
  <div
    class="w-100 text-center d-flex flex-row align-items-center justify-content-between flex-shrink-1 p-3"
    style="height: 60px"
  >
    <a
      target="_blank"
      href="https://pkspot.app"
      class="text-decoration-none text-center text-light text-wrap"
    >
      <img
        ngSrc="/assets/logos/pkspot/pkspot_logo_oneline_dark.png"
        alt="PK Spot"
        class="mw-100 mh-100"
        width="200"
        height="33.78"
      />
    </a>
    <a
      mat-stroked-button
      target="_blank"
      href="https://pkspot.app/map"
      class="d-none d-sm-flex"
    >
      <mat-icon>map</mat-icon>
      <span i18n>Open global spot map</span>
    </a>
    <a
      href="https://pkspot.app/"
      target="_blank"
      mat-mini-fab
      class="d-flex d-sm-none"
      color="primary"
    >
      <mat-icon> open_in_new </mat-icon>
    </a>
  </div>
  <div class="flex-grow-1">
    <router-outlet></router-outlet>
  </div>
</div>
}

<!-- Language menu -->
<mat-menu #langMenu="matMenu" id="langMenu">
  @for(code of availableLanguageCodes; track code ) {
  <a mat-menu-item [href]="'/' + code + '/'">{{
    languageCodes[code].name_native
  }}</a>
  }
</mat-menu>

<!-- User FAB -->
<!-- <button
  mat-fab
  color="primary"
  class="profile-icon-button login-fab d-none d-md-block"
  [matMenuTriggerFor]="userMenu"
>
  @if (!authService.isSignedIn) {
  <mat-icon>person_outline</mat-icon>
  }
  <img
    *ngIf="authService.isSignedIn && authService.user?.data?.profilePicture"
    [ngSrc]="
      storageService.getSpotMediaURL(
        authService.user.data.profilePicture,
        200
      )
    "
    width="56"
    height="56"
  />
</button> -->

<mat-menu #userMenu="matMenu" id="userMenu">
  @for(button of (authService.isSignedIn ? authenticatedUserMenuConfig :
  unauthenticatedUserMenuConfig); track button) { @if(button.link) {
  <a [routerLink]="button.link">
    <button mat-menu-item>
      <mat-icon>{{ button.icon }}</mat-icon>
      <span>{{ button.name }}</span>
    </button>
  </a>
  } @else if(button.function) {
  <button mat-menu-item (click)="button.function()">
    <mat-icon>{{ button.icon }}</mat-icon>
    <span>{{ button.name }}</span>
  </button>

  } @else {
  <button
    mat-menu-item
    [matMenuTriggerFor]="button.menu == 'lang' ? langMenu : userMenu"
  >
    <mat-icon>{{ button.icon }}</mat-icon>
    <span>{{ button.name }}</span>
  </button>
  } }
</mat-menu>
